import { IPlayer } from "@grassrootly/api/entities";
import { AuthenticatePayload } from "@grassrootly/api/gateways";
import server from "@grassrootly/api/providers/supabase-provider/Server";
import withErrorCheck from "../CheckError";

export const Authenticate = async ({ email, password }: AuthenticatePayload): Promise<IPlayer> => {
  const data = withErrorCheck(await server.auth.signInWithPassword({ email, password }));
  const players = withErrorCheck(await server.from("Players").select("*").eq("user_id", data.user.id));
  if (!players || !players.length) {
    throw new Error("No player found");
  }
  const player = players[0];
  return {
    ...player,
    user_id: data.user.id,
    user: {
      email: data.user.email || "",
      uid: data.user.id,
      created_at: data.user.created_at,
      confirmed_at: data.user.confirmed_at,
    },
    auth: {
      access_token: data.session.access_token,
      refresh_token: data.session.refresh_token,
      expires_in: data.session.expires_in,
      expires_at: data.session.expires_at,
    },
  };
};
